import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import DeleteAccount from './DeleteAccount';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/privacy-policy') {
      setCurrentPage('privacy-policy');
    } else if (path === '/terms-and-conditions') {
      setCurrentPage('terms-and-conditions');
    } else if (path === '/delete-account') {
      setCurrentPage('delete-account');
    } else {
      setCurrentPage('home');
    }
  }, []);

  const navigate = (page) => {
    setCurrentPage(page);
    if (page === 'privacy-policy') {
      window.history.pushState({}, '', '/privacy-policy');
    } else if (page === 'terms-and-conditions') {
      window.history.pushState({}, '', '/terms-and-conditions');
    } else if (page === 'delete-account') {
      window.history.pushState({}, '', '/delete-account');
    } else {
      window.history.pushState({}, '', '/');
    }
  };

  return (
    <div className="App">
      <Header onNavigate={navigate} />
      {currentPage === 'home' && <Home />}
      {currentPage === 'privacy-policy' && <PrivacyPolicy />}
      {currentPage === 'terms-and-conditions' && <TermsAndConditions />}
      {currentPage === 'delete-account' && <DeleteAccount />}
      <Footer onNavigate={navigate} />
    </div>
  );
}

export default App;